module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accommodationwrapper"
  }, [_c('Loading', {
    attrs: {
      "show": !_vm.webpools.length
    }
  }), _vm._v(" "), _vm._l((_vm.pools), function(pool, index) {
    return _c('div', {
      key: index,
      class: 'admin-table-wrapper ' + (pool.active ? 'open' : 'closed')
    }, [_c('h2', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          pool.active = !pool.active
        }
      }
    }, [_vm._v(_vm._s(pool.display_name || pool.name))])]), _vm._v(" "), (pool.active) ? _c('table', {
      staticClass: "admin-table",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('tbody', [(index) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "vertical-table"
    }, [_c('tr', [_c('th', [_vm._v("\n                  Namn (visas om inte visningsnamn är ifyllt, kan inte ändras härifrån)\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.name),
        expression: "pool.name"
      }],
      staticClass: "large",
      attrs: {
        "disabled": "",
        "readonly": ""
      },
      domProps: {
        "value": (pool.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Visningsnamn (visas om ifyllt)\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.display_name),
        expression: "pool.display_name"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.display_name)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'visningsnamn')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "display_name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Videolänk (Bunny/Vimeo)\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.video),
        expression: "pool.video"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.video)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'video')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "video", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Kartlänk (PDF)\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.map_link),
        expression: "pool.map_link"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.map_link)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'karta')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "map_link", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Dölj karta\n                ")]), _vm._v(" "), _c('td', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.hide_map),
        expression: "pool.hide_map"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(pool.hide_map) ? _vm._i(pool.hide_map, null) > -1 : (pool.hide_map)
      },
      on: {
        "change": [function($event) {
          var $$a = pool.hide_map,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(pool, "hide_map", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(pool, "hide_map", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(pool, "hide_map", $$c)
          }
        }, function($event) {
          return _vm.updatePool(pool, 'kartvisning')
        }]
      }
    }), _vm._v(" Dölj karta\n                  ")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Beskrivning\n                ")]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.short_description),
        expression: "pool.short_description"
      }],
      staticClass: "large",
      attrs: {
        "rows": "6"
      },
      domProps: {
        "value": (pool.short_description)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'beskrivning')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "short_description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Punkter (en ny punkt per rad)\n                ")]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.bullet_points),
        expression: "pool.bullet_points"
      }],
      staticClass: "large",
      attrs: {
        "rows": "6"
      },
      domProps: {
        "value": (pool.bullet_points)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'USP-punkter')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "bullet_points", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Bildlänk – stor bild\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.image),
        expression: "pool.image"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.image)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'stor bild')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "image", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "image-preview",
      attrs: {
        "src": pool.image
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Bildlänk – miniatyrbild\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.image_thumbnail),
        expression: "pool.image_thumbnail"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.image_thumbnail)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'minitiatyrbild')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "image_thumbnail", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "image-preview",
      attrs: {
        "src": pool.image_thumbnail
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Incheckningstid\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.check_in_time),
        expression: "pool.check_in_time"
      }],
      domProps: {
        "value": (pool.check_in_time)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'incheckningstid')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "check_in_time", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Utcheckningstid\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.check_out_time),
        expression: "pool.check_out_time"
      }],
      domProps: {
        "value": (pool.check_out_time)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'utcheckningstid')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "check_out_time", $event.target.value)
        }
      }
    })])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (pool.active) ? _c('table', {
      staticClass: "admin-table"
    }, [_c('tbody', [_vm._m(0, true), _vm._v(" "), _vm._l((pool.units), function(unit, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v("\n            #" + _vm._s(unit.id) + "\n          ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.show_web),
          expression: "unit.show_web"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": ""
        },
        domProps: {
          "checked": Array.isArray(unit.show_web) ? _vm._i(unit.show_web, null) > -1 : (unit.show_web)
        },
        on: {
          "change": function($event) {
            var $$a = unit.show_web,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(unit, "show_web", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(unit, "show_web", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(unit, "show_web", $$c)
            }
          }
        }
      }), _vm._v(" "), (unit.show_web) ? _c('a', {
        attrs: {
          "href": "#",
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.openUnit(unit)
          }
        }
      }, [_vm._v(" Visa ")]) : _vm._e(), _vm._v(" "), (!unit.show_web) ? _c('span', [_vm._v(" Visa")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(unit.name) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(unit.description_title) + "\n          ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.display_name),
          expression: "unit.display_name"
        }],
        domProps: {
          "value": (unit.display_name)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'namn')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "display_name", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.subtitle),
          expression: "unit.subtitle"
        }],
        domProps: {
          "value": (unit.subtitle)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'beskrivning')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "subtitle", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.night_storage),
          expression: "unit.night_storage"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(unit.night_storage) ? _vm._i(unit.night_storage, null) > -1 : (unit.night_storage)
        },
        on: {
          "change": [function($event) {
            var $$a = unit.night_storage,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(unit, "night_storage", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(unit, "night_storage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(unit, "night_storage", $$c)
            }
          }, function($event) {
            return _vm.updateUnit(unit, 'nattförvaring')
          }]
        }
      }), _vm._v(" Nattförvaring\n            ")]), _vm._v(" "), _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.has_mandatory_cleaning),
          expression: "unit.has_mandatory_cleaning"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(unit.has_mandatory_cleaning) ? _vm._i(unit.has_mandatory_cleaning, null) > -1 : (unit.has_mandatory_cleaning)
        },
        on: {
          "change": [function($event) {
            var $$a = unit.has_mandatory_cleaning,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(unit, "has_mandatory_cleaning", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(unit, "has_mandatory_cleaning", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(unit, "has_mandatory_cleaning", $$c)
            }
          }, function($event) {
            return _vm.updateUnit(unit, 'obl. slutstäd')
          }]
        }
      }), _vm._v(" Obl. slutstäd\n            ")])]), _vm._v(" "), _c('td', [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.use_unit_count),
          expression: "unit.use_unit_count"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(unit.use_unit_count) ? _vm._i(unit.use_unit_count, null) > -1 : (unit.use_unit_count)
        },
        on: {
          "change": [function($event) {
            var $$a = unit.use_unit_count,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(unit, "use_unit_count", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(unit, "use_unit_count", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(unit, "use_unit_count", $$c)
            }
          }, function($event) {
            return _vm.updateUnit(unit, 'visning av antal kvar')
          }]
        }
      }), _vm._v(" Visa antal kvar\n            ")]), _vm._v(" "), _c('label', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.price_type),
          expression: "unit.price_type"
        }],
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(unit, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.updateUnit(unit, 'pristyp')
          }]
        }
      }, _vm._l((['thursday', 'saturday']), function(i) {
        return _c('option', {
          key: i,
          domProps: {
            "value": i
          }
        }, [_vm._v("\n                  " + _vm._s({
          thursday: '-',
          saturday: 'Lördag',
        } [i]) + "\n                ")])
      }), 0)])]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.image),
          expression: "unit.image"
        }],
        domProps: {
          "value": (unit.image)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'bild')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "image", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.webpool_id),
          expression: "unit.webpool_id"
        }],
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(unit, "webpool_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.updateUnit(unit, 'områdestillhörighet')
          }]
        }
      }, _vm._l((_vm.webpools), function(p) {
        return _c('option', {
          key: p.id,
          domProps: {
            "value": p.id
          }
        }, [_vm._v("\n                " + _vm._s(p.display_name || p.name) + "\n              ")])
      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.check_in_time),
          expression: "unit.check_in_time"
        }],
        domProps: {
          "value": (unit.check_in_time)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'incheckning')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "check_in_time", $event.target.value)
          }
        }
      }), _c('br'), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.check_out_time),
          expression: "unit.check_out_time"
        }],
        domProps: {
          "value": (unit.check_out_time)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'utcheckning')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "check_out_time", $event.target.value)
          }
        }
      })])])
    })], 2)]) : _vm._e()])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "header"
  }, [_c('th', [_vm._v("\n            #\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Visa webb\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Namn 1\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Namn 2\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Visningsnamn\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Kort beskrivning / Nattförvaring\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Antal kvar / Ankomst\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Bildlänk\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Område\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Tider\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a985d40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Accomodation.vue
// module id = 907
// module chunks = 0